import React, { useState } from 'react';
import { api } from '@/lib/api';
import { Send, Mail } from 'lucide-react';
import useSEO from '@/hooks/useSEO';

export default function Contact() {
    useSEO({
        title: 'Contact Linguistic Quest — support, content suggestions, advertising',
        description: 'Reach the Linguistic Quest team. General queries hello@linguisticquest.com, advertising info@linguisticquest.com, schools quotes available on request.',
        path: '/contact',
    });
    const [form, setForm] = useState({ name: '', email: '', subject: '', message: '', source: 'support_page' });
    const [status, setStatus] = useState('idle');
    const submit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        try { await api.post('/contact', form); setStatus('sent'); setForm({ ...form, message: '' }); }
        catch { setStatus('error'); }
    };
    return (
        <main className="max-w-3xl mx-auto px-6 py-16" data-testid="page-contact">
            <p className="text-sm font-semibold uppercase tracking-wider text-lq-purple-500">Contact</p>
            <h1 className="mt-2 font-display text-4xl md:text-5xl font-semibold text-lq-ink-black">We're better when you tell us how to be better.</h1>
            <p className="mt-4 text-lq-ink-700">Every message reaches a real human on our team. For billing, account, or content questions, we typically respond within one working day.</p>
            <a href="mailto:feedback@linguisticquest.com" className="mt-4 inline-flex items-center gap-2 text-lq-purple-700 hover:text-lq-purple-900 font-medium" data-testid="contact-email-link">
                <Mail size={16} /> feedback@linguisticquest.com
            </a>
            <form onSubmit={submit} className="mt-10 space-y-4" data-testid="contact-form">
                <div className="grid sm:grid-cols-2 gap-4">
                    <label className="block">
                        <span className="text-sm font-medium text-lq-ink-900">Your name</span>
                        <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 w-full rounded-lg border border-lq-ink-300 px-3 py-2" data-testid="contact-name" />
                    </label>
                    <label className="block">
                        <span className="text-sm font-medium text-lq-ink-900">Email</span>
                        <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 w-full rounded-lg border border-lq-ink-300 px-3 py-2" data-testid="contact-email" />
                    </label>
                </div>
                <label className="block">
                    <span className="text-sm font-medium text-lq-ink-900">Subject</span>
                    <input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="mt-1 w-full rounded-lg border border-lq-ink-300 px-3 py-2" data-testid="contact-subject" />
                </label>
                <label className="block">
                    <span className="text-sm font-medium text-lq-ink-900">Message</span>
                    <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1 w-full rounded-lg border border-lq-ink-300 px-3 py-2" data-testid="contact-message" />
                </label>
                <button disabled={status === 'sending'} className="inline-flex items-center gap-2 bg-lq-purple-500 text-white font-semibold px-6 py-3 rounded-full hover:bg-lq-purple-700 disabled:opacity-60" data-testid="contact-submit">
                    <Send size={16} /> {status === 'sending' ? 'Sending…' : status === 'sent' ? 'Sent, thank you' : 'Send message'}
                </button>
                {status === 'error' && <p className="text-sm text-lq-error" role="alert">Something went wrong. Please email feedback@linguisticquest.com directly.</p>}
            </form>
        </main>
    );
}
